import { render } from "./VerbalFluencyInterview.vue?vue&type=template&id=4599edb8&scoped=true"
import script from "./VerbalFluencyInterview.vue?vue&type=script&lang=js"
export * from "./VerbalFluencyInterview.vue?vue&type=script&lang=js"

import "./VerbalFluencyInterview.vue?vue&type=style&index=0&id=4599edb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4599edb8"]])

export default __exports__